import { render, staticRenderFns } from "./ReceiveGoods.vue?vue&type=template&id=fe1fdfc0"
import script from "./ReceiveGoods.vue?vue&type=script&lang=js"
export * from "./ReceiveGoods.vue?vue&type=script&lang=js"
import style0 from "./ReceiveGoods.vue?vue&type=style&index=0&id=fe1fdfc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports